import {
    type FC
} from "react";
import type IDataTableViewOptionsProps from "./type";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useDataTableContext
} from "../../context";
import {
    SlidersHorizontal as SlidersHorizontalIcon
} from "lucide-react-native";
import DropdownMenu from "../../../dropdownMenu";
import Button from "../../../button";

const DataTableViewOptions: FC<IDataTableViewOptionsProps> = ({
    customTheme: customThemeProp,
    side = "bottom",
    align = "end",
    style,
    title
}) => {
    const context = useDataTableContext({
        part: "ViewOptions"
    });

    const {
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    if(!context || context.layout === "cards") {
        return null;
    }

    const currentTheme = customThemeProp ?? context.customTheme;

    const hideableColumns = context.allColumns.filter((column) => column.isHideable !== false && !column.isHeaderHidden);

    const visibleCount = context.columns.filter((column) => !column.isHeaderHidden).length;

    const renderIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <SlidersHorizontalIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    return <DropdownMenu
        title={title ?? localize("data-table-view")}
        customLocalize={context.customLocalize}
        customTheme={currentTheme}
        align={align}
        side={side}
    >
        <DropdownMenu.Trigger
            isDisabled={context.isPermissionDenied}
        >
            <Button
                title={title ?? localize("data-table-view")}
                isDisabled={context.isPermissionDenied}
                customTheme={currentTheme}
                onPress={() => undefined}
                icon={renderIcon}
                variant="outline"
                type="neutral"
                style={style}
                size="small"
            />
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
            <DropdownMenu.Label
                title={localize("data-table-toggle-columns")}
            />
            {
                hideableColumns.map((column) => {
                    const isChecked = context.columns.some((item) => item.id === column.id);

                    return <DropdownMenu.CheckboxItem
                        onChange={(isNextChecked) => context.handleColumnVisibilityChange({
                            ...context.columnVisibility,
                            [column.id]: isNextChecked
                        })}
                        isDisabled={isChecked && visibleCount <= 1}
                        title={column.header}
                        isChecked={isChecked}
                        key={column.id}
                    />;
                })
            }
            <DropdownMenu.Separator />
            <DropdownMenu.Item
                onPress={() => context.handleColumnVisibilityChange({})}
                title={localize("data-table-show-all-columns")}
            />
        </DropdownMenu.Content>
    </DropdownMenu>;
};
export default DataTableViewOptions;
